import './App.css';
import Contact from './components/contact/Contact';
import LandingPage from './pages/landingPage/LandingPage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import ProjectsPage from './pages/projectsPage/ProjectsPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route exact path="/" element={<LandingPage />} />
          <Route path="/all-projects" element={<ProjectsPage />} />
        </Routes>
        <Contact />
      </div>
    </Router>
  );
}

export default App;
